import React, { useState } from "react";
import moment from "moment";
import groupBy from "lodash/groupBy";
import { Form, Row, Space } from "@masterteam/mt-design-react";
import { useIntl, FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import Collapse from "../Collapse";
import KPIMeasuresField from "../KPIMeasuresField";
import FormulaBuilder from "../FormulaBuilder";
import ParametersField from "../ParametersField";

import api from "../../providers/api";
import {
  getLookupName,
  UnitOfMeasureList,
  addToast,
  formatDate,
  UnitOfMeasure,
  cleanKPIMeasures,
} from "../../helpers";

import { ReactComponent as ChangeKpiParametersIcon } from "../../assets/images/change-kpi-parameters.svg";

import "./style.scss";

const { Field } = Form;

const generateFormulaRegex = (parameters = []) =>
  new RegExp(
    `\\+|-|\\*|\\/|100%${parameters.reduce(
      (acc, item) => `${acc}|${item.ParameterName}`,
      ""
    )}`,
    "g"
  );

const ChangeActualValues = ({
  kpiDetails,
  isReadOnly,
  lists,
  values,
  setFieldValue,
}) => {
  const intl = useIntl();
  const isAr = intl.locale === "ar";

  const theme = useSelector(({ theme }) => theme);

  let formula = [];

  if (kpiDetails.Formula) {
    const regex = generateFormulaRegex(kpiDetails.Parameters);
    formula = kpiDetails.Formula.match(regex);
  }

  return (
    <Collapse
      defaultExpanded
      title={intl.formatMessage({
        id: "change-kpi-parameters",
      })}
      icon={<ChangeKpiParametersIcon />}
    >
      <Space direction="vertical" size="large">
        <Space className="section" direction="vertical">
          <Space className="title-wrapper" align="center" size="medium">
            <div className="title">
              <FormattedMessage id="change-request.current-values" />
            </div>
            <hr />
          </Space>

          <Space direction="vertical" size="large" className="body">
            <ParametersField
              isEditMode={false}
              isReadOnly
              isChangeRequest
              parametersList={kpiDetails?.Parameters}
            />

            <hr />

            <Field
              label={intl.formatMessage({ id: "kpi.parameter-formula" })}
              inputProps={{
                placeholder: intl.formatMessage({
                  id: "kpi.parameter-formula",
                }),
                value: formula?.join(""),
              }}
              hideErrorMessage
              disabled
            />
          </Space>
        </Space>

        <Space className="section" direction="vertical">
          <Space
            className="updated-values-title-wrapper"
            align="center"
            size="medium"
          >
            <div className="title ">
              <FormattedMessage id="change-request.values-after-change" />
            </div>
            <hr />
          </Space>

          <Space direction="vertical" size="large" className="body">
            <ParametersField isEditMode={isReadOnly} isReadOnly={isReadOnly} />

            <FormulaBuilder isEditMode={isReadOnly} isReadOnly={isReadOnly} />
          </Space>
        </Space>
      </Space>
    </Collapse>
  );
};

export default ChangeActualValues;
